var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16667C9.49667 9.16667 11.3125 9.745 12.6483 10.56C13.315 10.9667 13.885 11.4467 14.2967 11.9683C14.7017 12.4808 15 13.0942 15 13.75C15 14.4542 14.6575 15.0092 14.1642 15.405C13.6975 15.78 13.0817 16.0283 12.4275 16.2017C11.1125 16.5492 9.3575 16.6667 7.5 16.6667C5.6425 16.6667 3.8875 16.55 2.5725 16.2017C1.91833 16.0283 1.3025 15.78 0.835833 15.405C0.341666 15.0083 0 14.4542 0 13.75C0 13.0942 0.298333 12.4808 0.703333 11.9675C1.115 11.4467 1.68417 10.9675 2.35167 10.5592C3.6875 9.74583 5.50417 9.16667 7.5 9.16667ZM7.5 0C8.60507 0 9.66488 0.438987 10.4463 1.22039C11.2277 2.00179 11.6667 3.0616 11.6667 4.16667C11.6667 5.27174 11.2277 6.33154 10.4463 7.11294C9.66488 7.89435 8.60507 8.33333 7.5 8.33333C6.39493 8.33333 5.33512 7.89435 4.55372 7.11294C3.77232 6.33154 3.33333 5.27174 3.33333 4.16667C3.33333 3.0616 3.77232 2.00179 4.55372 1.22039C5.33512 0.438987 6.39493 0 7.5 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/nameIcon.435d8003a716b4f8fdb6578fa0863925.svg";
export { ForwardRef as ReactComponent };